<template>

    <v-section name="Default" :expanded="expanded">
        <div ref="block-items" class="block-items">
            <div class="block-item block-item-default" v-for="item in library" :key="item.block.type">
                <div class="d-flex align-items-center">
                    <i class="icon" :class="icons[item.block.type]" />
                    <span class="ml-10">{{ item.block.name }}</span>
                </div>
                <i class="fas fa-arrows text-muted"></i>
            </div>
        </div>
    </v-section>

</template>

<style scoped lang="scss">

    .block-items {
        display: grid;
        gap: 5px;
        .block-item {
            @include font-medium(13px);
            align-items: center;
            background: #fff;
            border-radius: 3px;
            border: 1px solid $color-rule;
            cursor: pointer;
            display: flex;
            height: 40px;
            justify-content: space-between;
            padding: 0 15px;
            position: relative;
            text-align: center;
            transition: border-color .3s;
            &:hover {
                border-color: $color-text;
            }
            .icon {
                font-size: 16px;
                text-align: center;
                width: 20px;
            }
        }
    }

</style>

<script>

import Section from './Section';
import Sortable from 'sortablejs';

export default {

    components: {
        'v-section': Section,
    },

    props: {
        expanded: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            icons: {
                'headline': 'fas fa-heading',
                'paragraph': 'fas fa-align-left',
                'image': 'fas fa-image',
                'logo': 'fas fa-star',
                'divider': 'fas fa-page-break',
                'spacer': 'fas fa-arrows-v',
                'button': 'fas fa-arrow-alt-square-down',
                'social': 'fas fa-thumbs-up',
                'code': 'fas fa-code',
                'badge': 'fas fa-badge',
                'unsub': 'fas fa-comment-times',
            },
        }
    },

    mounted() {
        Sortable.create(this.$refs['block-items'], {
            group: {
                name: 'library',
                pull: 'clone',
                put: false,
            },
            sort: false,
        });
    },

    computed: {

        library() {
            return this.$store.getters['builder/library'];
        },

    },

}

</script>